"use strict";

var _toConsumableArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _SliderStyle = _interopRequireDefault(require("./SliderStyle"));
var _Types = require("../Types");
var _InputMinMaxView = _interopRequireDefault(require("./InputMinMaxView"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var SliderView = function SliderView(_ref) {
  var classes = _ref.classes,
    facet = _ref.facet,
    onSliderToggle = _ref.onSliderToggle,
    filterState = _ref.filterState;
  var minLowerBound = facet.minLowerBound,
    maxUpperBound = facet.maxUpperBound,
    quantifier = facet.quantifier,
    datafield = facet.datafield,
    facetValues = facet.facetValues;
  var lowerBoundValue = facetValues[0];
  var upperBoundValue = facetValues[1];

  // Determines whether the lower bound and upper bound values are valid
  var isValid = function isValid() {
    var checks = [lowerBoundValue <= upperBoundValue, lowerBoundValue >= minLowerBound, upperBoundValue <= maxUpperBound];
    return checks.every(function (condition) {
      return condition === true;
    });
  };
  var handleChangeCommittedSlider = function handleChangeCommittedSlider(value) {
    if (!value.includes('')) {
      onSliderToggle(_objectSpread({
        sliderValue: value
      }, facet));
    }
  };
  var _ref2 = (0, _react.useState)([lowerBoundValue, upperBoundValue]),
    _ref3 = _slicedToArray(_ref2, 2),
    sliderValue = _ref3[0],
    setSliderValue = _ref3[1];
  (0, _react.useEffect)(function () {
    if (filterState && datafield && filterState[datafield]) {
      setSliderValue(_toConsumableArray(filterState[datafield]));
    } else {
      setSliderValue([minLowerBound, maxUpperBound]);
    }
  }, [facet]);
  var handleChangeSlider = function handleChangeSlider(index, value) {
    if (!value.includes('')) {
      setSliderValue(_toConsumableArray(value));
    }
  };
  var valuetext = function valuetext(value) {
    return "".concat(value);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.sliderRoot
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.minMaxInputs
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.minValue
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.minInputLabel
  }, "Min:"), /*#__PURE__*/_react.default.createElement(_InputMinMaxView.default, {
    lowerBoundVal: sliderValue[0],
    upperBoundVal: sliderValue[1],
    minLowerBound: minLowerBound,
    maxUpperBound: maxUpperBound,
    type: _Types.silderTypes.INPUT_MIN,
    onInputChange: handleChangeCommittedSlider
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.maxValue
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.maxInputLabel
  }, "Max:"), /*#__PURE__*/_react.default.createElement(_InputMinMaxView.default, {
    lowerBoundVal: sliderValue[0],
    upperBoundVal: sliderValue[1],
    minLowerBound: minLowerBound,
    maxUpperBound: maxUpperBound,
    type: _Types.silderTypes.INPUT_MAX,
    onInputChange: handleChangeCommittedSlider
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.slider
  }, /*#__PURE__*/_react.default.createElement(_core.Slider, {
    disableSwap: true,
    getAriaValueText: valuetext,
    onChange: handleChangeSlider,
    onChangeCommitted: function onChangeCommitted(event, value) {
      return handleChangeCommittedSlider(value);
    },
    value: _toConsumableArray(sliderValue),
    valueLabelDisplay: "auto",
    min: minLowerBound,
    max: maxUpperBound,
    classes: {
      rail: classes.rail,
      thumb: isValid() ? classes.thumb : classes.invalidThumb,
      track: isValid() ? classes.track : classes.invalidTrack
    }
  })), /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: classes.lowerUpperBound
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.lowerBound
  }, minLowerBound), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.upperBound
  }, maxUpperBound))), (sliderValue[0] > minLowerBound || sliderValue[1] < maxUpperBound) && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: isValid() ? classes.sliderText : classes.invalidSliderText
  }, sliderValue[0], ' - ', sliderValue[1], "\xA0", quantifier));
};
var _default = (0, _core.withStyles)(_SliderStyle.default)(SliderView);
exports.default = _default;